<footer class="bg-slate-900 text-slate-300">
  <div class="mx-auto grid max-w-7xl gap-10 px-4 py-12 md:grid-cols-3 md:px-6 lg:px-8">
    <div class="min-w-0">
      <a routerLink="/" class="inline-flex items-center gap-2.5" [attr.aria-label]="site().brand.name + ' - Trang chủ'">
        <span
          class="flex h-10 w-10 items-center justify-center rounded-2xl bg-gradient-to-br from-emerald-600 via-teal-600 to-sky-700"
        >
          <mat-icon class="text-white" svgIcon="hero:eco"></mat-icon>
        </span>
        <span class="text-lg font-black tracking-tight text-white">{{ site().brand.name }}</span>
      </a>
      <p class="mt-4 max-w-sm text-sm leading-7 text-slate-400">
        {{ site().footer.description }}
      </p>
    </div>

    <nav aria-label="Liên kết chân trang">
      <p class="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">{{ site().footer.navHeading }}</p>
      <ul class="mt-4 space-y-2.5 text-sm">
        @for (link of links; track link.path) {
          <li>
            <a [routerLink]="link.path" class="font-semibold text-slate-300 transition hover:text-emerald-300">
              {{ link.label }}
            </a>
          </li>
        }
      </ul>
    </nav>

    <div class="min-w-0">
      <p class="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">{{ site().footer.contactHeading }}</p>
      <ul class="mt-4 space-y-3 text-sm">
        <li class="flex items-start gap-3">
          <mat-icon class="mt-0.5 !h-5 !w-5 shrink-0 text-emerald-400" svgIcon="hero:phone"></mat-icon>
          <a [href]="'tel:' + site().contact.phone" class="font-semibold hover:text-emerald-300">{{ site().contact.phoneLabel }} {{ site().contact.phoneDisplay }}</a>
        </li>
        <li class="flex items-start gap-3">
          <mat-icon class="mt-0.5 !h-5 !w-5 shrink-0 text-emerald-400" svgIcon="hero:mail"></mat-icon>
          <a [href]="'mailto:' + site().contact.email" class="break-all font-semibold hover:text-emerald-300">{{ site().contact.email }}</a>
        </li>
        <li class="flex items-start gap-3">
          <mat-icon class="mt-0.5 !h-5 !w-5 shrink-0 text-emerald-400" svgIcon="hero:place"></mat-icon>
          <span>{{ site().contact.address }}</span>
        </li>
        <li class="flex items-start gap-3">
          <mat-icon class="mt-0.5 !h-5 !w-5 shrink-0 text-emerald-400" svgIcon="hero:schedule"></mat-icon>
          <span>{{ site().contact.workingHours }}</span>
        </li>
        @if (site().contact.zaloUrl) {
          <li class="flex items-start gap-3">
            <mat-icon class="mt-0.5 !h-5 !w-5 shrink-0 text-emerald-400" svgIcon="hero:forum"></mat-icon>
            <a [href]="site().contact.zaloUrl" target="_blank" rel="noopener" class="font-semibold hover:text-emerald-300">Zalo</a>
          </li>
        }
        @if (site().contact.facebookUrl) {
          <li class="flex items-start gap-3">
            <mat-icon class="mt-0.5 !h-5 !w-5 shrink-0 text-emerald-400" svgIcon="hero:open_in_new"></mat-icon>
            <a [href]="site().contact.facebookUrl" target="_blank" rel="noopener" class="font-semibold hover:text-emerald-300">Facebook</a>
          </li>
        }
      </ul>
    </div>
  </div>

  <div class="border-t border-white/10">
    <p class="mx-auto max-w-7xl px-4 py-5 text-xs text-slate-500 md:px-6 lg:px-8">{{ site().footer.copyright }}</p>
  </div>
</footer>
